<template>
<div>
    <div class="content-nav-wrapper">
        <div class="title-wrapper">
            <span class="title">{{ $t('comb.releasedTask') }}</span>
            <span>{{ $t('word.total') }} {{totalWorks}} {{ $t('word.item') }}</span>
        </div>
        <div class="tabs-wrapper">
            <button :class="all || 'active'" @click="getWorks(1,-1)"><span>{{ $t('word.all') }}</span></button>
            <button :class="release || 'active'" @click="getWorks(1,0)"><span>{{ $t('word.toBePaid') }}</span></button>
            <button :class="mass || 'active'" @click="getWorks(1,1)"><span>{{ $t('word.addition') }}</span></button>
            <button :class="choose || 'active'" @click="getWorks(1,2)"><span>{{ $t('word.selecting') }}</span></button>
            <button :class="make || 'active'" @click="getWorks(1,3)"><span>{{ $t('word.inProduction') }}</span></button>
            <button :class="done || 'active'" @click="getWorks(1,4)"><span>{{ $t('word.finished') }}</span></button>
        </div>
    </div>
    <div class="content-right-list" v-loading.body="loading">
        <div class="release-works-item" v-for="item in worksList">
            <div class="title">
                <!--<div>{{item.createTime|format-date('YYYY-MM-DD')}}</div>-->
                <div v-if="parseInt(item.statusId)===0">{{item.statusLabel}}</div>
                <div v-if="parseInt(item.statusId)!==0">{{item.viewStatusLabel}}</div>
            </div>
            <div class="content">
                <img v-if="item.demand.distributionOptionId === 3" :src="$store.state.IMG_HOST+'pay-album-icon@2x.png'" class="prop-img">
                <img :src="`${UPLOAD_IMG_HOST}${item.coverPath}`" alt="">
                <div>
                    <div class="content-words">
                        <p>{{item.name}}</p>
                        <p>{{ $t('word.type') }}：{{item.categoryLabel}}</p>
                    </div>
                    <div class="content-operate">
                        <!--<el-button v-if="item.statusId==0" @click="editWorks(item.materialId)" type="primary" size="small">{{ $t('word.edit') }}</el-button>-->
                        <el-button v-show="item.statusId==0" @click="pay(item.requirementId)" type="primary" size="small">{{ $t('comb.toPay') }}</el-button>
                        <el-button v-show="item.statusId==0" @click="open(item.requirementId)" type="primary" size="small">{{ $t('word.withDrew') }}</el-button>
                        <div class="column-layer">
                            <el-button v-show="item.statusId > 0 && (item.viewStatusId == 2 || item.viewStatusId == 1)" @click="lookupAnchor(item.requirementId)" type="primary" size="small">{{ $t('word.check') }}</el-button>
                            <el-button v-show="item.viewStatusId == 3 || item.viewStatusId == 4" style="margin: 0;" @click="lookupWorks(item.requirementId)" type="primary" size="small">{{ $t('word.check') }}</el-button>
                            <el-button v-show="item.statusId > 0 && item.isPublisher && item.cooperation.payment.prePay" class="order-detail" type="text" @click.native="showOrder(item.requirementId)" size="small">{{ $t('comb.orderDetail') }}</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="center-works-pagination" v-if="totalPages>=2">
            <el-pagination @current-change="changePage" :page-count="totalPages" layout="prev, pager, next"></el-pagination>
        </div>
    </div>
    <el-dialog :title="$t('comb.orderDetail')" v-model="orderDialog" size="tiny">
        <div class="order">
            <div><span>订单号：</span><span>{{ order.orderNumber }}</span></div>
            <div><span>支付金额：</span><span>￥{{ order.amount }}</span></div>
            <div><span>支付账户：</span><span>{{ order.account }}</span></div>
            <div><span>支付时间：</span><span>{{ order.payTime }}</span></div>
            <div><span>订单状态：</span><span>{{ $t('word.paid') }}</span></div>
        </div>
        <div class="order-buttons">
            <el-button v-if="false" size="large" type="primary" >{{ $t('word.refund') }}</el-button>
            <el-button size="large" @click.native="orderDialog=false;">{{ $t('word.close') }}</el-button>
        </div>
    </el-dialog>
</div>
</template>
<script>
import axios from 'axios';
import moment from 'moment';
export default {
    data() {
        return {
            all: true,
            mass: true,
            choose: true,
            make: true,
            done: true,
            release: true,
            pageSize: 4,
            pageIndex: 1,
            status: -1,
            totalWorks: 0,
            totalPages: 0,
            worksList: [],
            orderDialog: false,
            order: {
              amount: 0,
              orderNumber: -1,
              account: '',
              payTime: '',
              status: this.$i18n.t('word.paid')
            },
            loading: true
        }
    },
    mounted() {
        if (this.$route.query.subTab === 'mass') {
          this.getWorks(this.pageIndex, 1);
        } else {
          this.getWorks(this.pageIndex, -1);
        }
    },
    methods: {
        getWorks(pageIndex, status) {
            this.loading = true;
            const cb = () => {
                this.status = status;
                this.pageIndex = pageIndex;
                this.totalPages = 0;
                axios.get(`/api/manager/requirement/list/status/${this.status}/page/${pageIndex}`).then(result => {
                    if (result.data.code == 200) {
                        const res = result.data.data;
                        this.totalWorks = res.total;
                        this.totalPages = res.pages;
                        this.worksList = res.items;
                        this.loading = false;
                    }
                }).catch(error => {
                    this.$notify.error({
                        title: this.$i18n.t('word.error'),
                        message: error.message
                    });
                });
            };
            switch (parseInt(status)) {
                case -1:
                    this.all = false;
                    this.mass = this.choose = this.make = this.done = this.release = true;
                    cb();
                    break;
                case 1:
                    this.mass = false;
                    this.all = this.choose = this.make = this.done = this.release = true;
                    cb();
                    break;
                case 2:
                    this.choose = false;
                    this.all = this.mass = this.make = this.done = this.release = true;
                    cb();
                    break;
                case 3:
                    this.make = false;
                    this.all = this.choose = this.mass = this.done = this.release = true;
                    cb();
                    break;
                case 4:
                    this.done = false;
                    this.all = this.choose = this.make = this.mass = this.release = true;
                    cb();
                    break;
                case 0:
                    this.release = false;
                    this.all = this.choose = this.make = this.mass = this.done = true;
                    cb();
                    break;
            }
        },
        changePage(pageIndex) {
            this.pageIndex = pageIndex;
            axios.get(`/api/manager/requirement/list/status/${this.status}/page/${pageIndex}`).then(result => {
                if (result.data.code == 200) {
                    const res = result.data.data;
                    this.totalWorks = res.total;
                    this.totalPages = res.pages;
                    this.worksList = res.items;
                } else {
                    this.$message({
                        type: 'error',
                        message: result.data.message
                    });
                }
            }).catch(error => {
                this.$message({
                    type: 'error',
                    message: error.message
                });
            });
        },
        pay (requirementId) {
          this.$router.push({
            name: 'toPayPage',
            params: {requirementId: requirementId}
          });
        },
        open(requirementId) {
            this.$confirm(this.$i18n.t('sen.permanentlyDeleteConfirm'), this.$i18n.t('word.tips'), {
                lockScroll: false,
                confirmButtonText: this.$i18n.t('word.ok'),
                cancelButtonText: this.$i18n.t('word.cancel'),
                type: 'warning',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        instance.confirmButtonLoading = true;
                        axios.post(`/api/manager/requirement/${requirementId}/delete`).then(res => {
                            if (res.data.code === 200) {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                                this.$message({
                                    type: 'success',
                                    message: this.$i18n.t('comb.successfullyDeleted')
                                });

                              axios.get(`/api/manager/requirement/list/status/${this.status}/page/${this.pageIndex}`).then(result => {
                                    if (result.data.code == 200) {
                                        const res = result.data.data;
                                        this.totalWorks = res.total;
                                        this.totalPages = res.pages;
                                        this.worksList = res.items;
                                    }
                                }).catch(error => {
                                    this.$message({
                                        type: 'error',
                                        message: error.message
                                    });
                                });
                            } else {
                              done();
                              this.$message({
                                type: 'warning',
                                message: res.data.message
                              })
                            }
                        }).catch(error => {
                            this.$message({
                                type: 'error',
                                message: error.message
                            });
                        });
                    } else {
                        done();
                        instance.confirmButtonLoading = false;
                    }
                }
            }).then(() => {}).catch(() => {});
        },
        showOrder(requirementId) {
          axios.get(`/api/manager/requirement/${requirementId}/order`).then(res => {
            if(res.data.code === 200 && res.data.data) {
              const data = res.data.data;
              this.order.orderNumber = data.merchantOrderNo;
              this.order.amount = data.amount;
              this.order.account = data.payChannelId === 42? '支付宝': '微信支付';
              this.order.payTime = moment(data.lastUpdateTime).format('YYYY-MM-DD HH:mm:ss');
              this.orderDialog = true;
            } else {
              this.$message({
                type: 'error',
                message: res.data.message || '订单数据不存在！',
                duration: 1500
              });
            }
          });
        },
        editWorks(id) {
            this.$router.push({
                name: 'baseInfo',
                query: {
                    materialId: id
                }
            });
        },
        lookupAnchor(id) {
            this.$router.push({name: 'taskDetailsMass', params: {id: id}});
        },
        lookupWorks(id) {
            this.$router.push({name: 'taskDetailsMaking', params: {id: id}});
        }
    },
    computed: {
        UPLOAD_IMG_HOST() {
            return this.$store.state.UPLOAD_IMG_HOST;
        }
    }
}
</script>
<style lang="sass" scoped>
    @import "../../../sass/copyright/taskMangement/task-management-list.scss";
    @import "../../../sass/icons.scss";
</style>



// WEBPACK FOOTER //
// TaskManagementList.vue?d2976374